const TrustBadges = () => {
  return (
    <div className="bg-gray-50 py-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mb-3">
              <i className="ri-shield-check-line text-3xl text-green-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1">Secure Payments</h3>
            <p className="text-xs text-gray-600">SSL Encrypted</p>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-3">
              <i className="ri-truck-line text-3xl text-blue-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1">Fast Shipping</h3>
            <p className="text-xs text-gray-600">Worldwide Delivery</p>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mb-3">
              <i className="ri-customer-service-2-line text-3xl text-purple-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1">24/7 Support</h3>
            <p className="text-xs text-gray-600">Always Here</p>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mb-3">
              <i className="ri-money-dollar-circle-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1">Best Prices</h3>
            <p className="text-xs text-gray-600">Price Match Guarantee</p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <i className="ri-star-fill text-yellow-500"></i>
            <i className="ri-star-fill text-yellow-500"></i>
            <i className="ri-star-fill text-yellow-500"></i>
            <i className="ri-star-fill text-yellow-500"></i>
            <i className="ri-star-fill text-yellow-500"></i>
            <span className="font-semibold ml-1">4.9/5</span>
            <span className="text-gray-500">(10,000+ Reviews)</span>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <i className="ri-user-line text-primary"></i>
            <span><strong>50,000+</strong> Happy Customers</span>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <i className="ri-checkbox-circle-line text-green-600"></i>
            <span><strong>99.8%</strong> Satisfaction Rate</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;
